import {useAppContext} from "../../utils/AppContext";

const Cta = () => {
    const {
        projectData,
        screenSize,
        handleSectionClick
    } = useAppContext();

    // Styles Configuration //
    const ctaContainer = (!screenSize)? 'cta-container' : `cta-container cta-container${screenSize}`;
    const sectionTitle = (!screenSize)? 'section-title' : `section-title section-title${screenSize}`;
    const primaryButton = (!screenSize)? 'primary-button' : `primary-button primary-button${screenSize}`;
    const primaryButtonText = (!screenSize)? 'primary-button-text' : `primary-button-text primary-button-text${screenSize}`;

    return (
        <div className={ctaContainer}>
            <h2 className={sectionTitle}>{projectData.finalCta.phrase}</h2>
            <button 
                className={primaryButton}
                onClick={() => handleSectionClick("offer")}
            >
                <span className={primaryButtonText}>{projectData.finalCta.button}</span>
            </button>
        </div>
    );

};

export default Cta;
